<app-camera #camera (pictureTaken)="pictureTaken($event, this.browserName, this.browserVersion)" [apiTime]="apiTime">
</app-camera>

<!-- success-modal -->
<div class="modal fade common-modal success-modal-camera customized-modal" id="success-modal-camera"
	data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 9999 !important">
	<div class="modal-dialog modal-sm modal-dialog-centered" style="max-width: 415px">
		<div class="modal-content" style="border: 0;">
			<div class="modal-body">
				<div class="common-modal-inner" style="max-width: inherit">
					<!-- <h4 class="mb20 text-dark-blue font-weight-700 nowrap" *ngIf="success">CONGRATULATIONS <span class="material-icons thumb_up-ani">thumb_up_off_alt</span></h4> -->
					<h3 *ngIf="success">Congratulations</h3>
					<p *ngIf="success" class="mt20 text-white">
						Your face is analyzed successfully
					</p>

					<div class="ovelShape2" *ngIf="webcamImage">
						<img [src]="webcamImage" alt="icon-success"
							class="icon-success-camera icon-camera-photo img-fluid" />
					</div>

					<h5 *ngIf="success" class="mt20 font-weight-500 text-center text-green">
						{{ message }}
					</h5>
					<h5 *ngIf="!success" class="mt20 font-weight-500 text-center text-red">
						{{ message }}
					</h5>
					<br />
					<div class="successButtonAni" *ngIf="success">
						<div class="circleAni">
							<label>&#10003;</label>
						</div>
					</div>
					<div class="errorButtonAni" *ngIf="!success">
						<div class="circleAni">
							<label>&#x2715;</label>
						</div>
					</div>
					<!-- <p class="p-16 mt10" *ngIf="success">for successful submission of your liveliness capture</p>
					<p class="p-16 mt10" *ngIf="success">In 3 seconds you will be redirected to your account opening journey </p> -->
					<div class="posi-rel  text-center">
						<div class="text-center mt-3" *ngIf="!success">
							<button class="btn common-btn common-btn-new btn-block" (click)="retry()">
								Retry
							</button>
						</div>

					</div>
					<p class="p-14 mt20 text-center poweredby">
						Powered by

					</p>
					<b _ngcontent-mpl-c6="">AiNxt.</b>

				</div>
			</div>
		</div>
	</div>
</div>

<section class="common-section ainxt-tech-section">
	<div class="container">
		<div class="row">
			<div class="col-lg-12">
				<!-- <img style="width: 150px; margin: 0 auto 15px;" width="150px" src="../../assets/images/Ainxt-tech-logo.png" alt="Ainxt-tech-logo" class="ainxt-tech-logo" /> -->
				<div class="common-step-form">
					<br />

					<p class="mt20" style="text-align: center;">
						Take a picture of you with good lighting <br />and a
						clear image
					</p>
					<p class="mt20 "></p>

					<div *ngIf="webcamImage; else showOvelShape" class="ovelShape2">
						<img [src]="webcamImage" />
					</div>
					<!-- <div>
						<h5 *ngIf="success" class="pichPink text-center">
							{{ message }}
						</h5>
						<h5 *ngIf="!success" class="pichPink text-center">
							{{ message }}
						</h5>
					</div> -->

					<ng-template #showOvelShape>
						<div class="ovelShape">
							<img src="assets/images/aManPic.png" width="100%" height="auto" style="opacity: 0.8" />
						</div>
					</ng-template>

					<p class="mt20 " style="text-align: center;">
						Make sure you face to the camera and the eyes
						<br />aren't closed
					</p>
					<br /><br />
					<button [disabled]="!isLocationCaptured"
						class="btn common-btn common-btn-new btn-block  ChangeLabel-btn"
						style="max-width: 420px; margin: auto" (click)="capture(); captureGeo()"
						*ngIf="isLoggedIn && isLocationCaptured">
						<img width="24px" height="18" src="assets/images/icon/icon-camera.svg" alt="icon-camera"
							class="common-camera-img mr10" />
						Capture
					</button>
					<button 
						class="btn common-btn common-btn-new btn-block  ChangeLabel-btn"
						style="max-width: 420px; margin: auto" (click)="capture(); captureGeo()"
						*ngIf="!isLocationCaptured">
						<img width="24px" height="18" src="assets/images/icon/icon-camera.svg" alt="icon-camera"
							class="common-camera-img mr10" />
						Fetching Location...
					</button>

					<p class="p-14 mt20 text-center poweredby">
						Powered by
						<b _ngcontent-mpl-c6="">AiNxt.</b>
					</p>

					<!-- <p class="p-14 poweredby mt30">Powered by <a href="https://www.ainxt.tech/" target="_blank"><img style="width: 60px!important;" width="60px
						" src="../../assets/images/Ainxt-tech-logo.png" alt="Ainxt-tech-logo" class="ainxt-poweredby-logo" /></a></p> -->
				</div>
			</div>
		</div>
	</div>
</section>
<div></div>

<div class="modal fade preview-img-modal" id="location-phone" data-backdrop="static" data-keyboard="false"
	tabindex="-1">
	<div class="modal-dialog modal-dialog-centered modal-md">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="staticBackdropLabel">
					Allow Permissions
				</h5>
			</div>
			<div class="modal-body">
				<div class="common-modal-inner-2">
					<div class="camera-code-wrap mb15">
						<h5>Location Permission is denied for your Phone:</h5>
						<p class="p-16 mb15">
							Steps to continue to use location
						</p>
						<ul class="camera-permission-ul">
							<li class="p-16">
								<em>1</em> Make Sure your Device location is
								enabled.
							</li>
							<li class="p-16">
								<em>2</em> Click the lock menu icon on top-right
								of the screen.
							</li>
							<li class="p-16">
								<em>3</em> Look for "Site Settings" go to
								Location"
							</li>
							<li class="p-16">
								<em>4</em> Look for Face Liveliness site and
								Allow location access"
							</li>
							<li class="p-16">
								<em>5</em> After Completing aboves steps Click
								on "Retry Button" given below"
							</li>
							<button (click)="reload()" class="btn common-btn common-btn-new btn-block">
								Retry
							</button>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- location-denied-modal -->
<div class="modal fade preview-img-modal" id="location-denied-modal" data-backdrop="static" data-keyboard="false"
	tabindex="-1">
	<div class="modal-dialog modal-dialog-centered modal-md">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="staticBackdropLabel">
					Allow Permissions
				</h5>
			</div>
			<div class="modal-body">
				<div class="common-modal-inner-2">
					<div class="camera-code-wrap mb15">
						<h5>Location Permission is denied:</h5>
						<p class="p-16 mb15">
							Steps to continue to use location
						</p>
						<ul class="camera-permission-ul">
							<li class="p-16">
								<em>1</em> Click the lock icon on top-left of
								the screen.
							</li>
							<li class="p-16">
								<em>2</em> Click "Site Settings"
							</li>
							<li class="p-16">
								<em>3</em> Click "Clear &amp; reset"
							</li>
							<li class="p-16">
								<em>4</em> Click on "Retry Button"
							</li>
							<button (click)="reload()" class="btn common-btn common-btn-new btn-block">
								Retry
							</button>
						</ul>
						<p class="p-14">
							<b>Note:</b> If you didn't deny location permission,
							kindly copy the link and open in Chrome Browser.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>